export default {"src":"/_next/static/media/delete-icon-red.84739f00.svg","height":14,"width":14};